export default "__VITE_ASSET__BmwLvF$h__"